// Error routes
export const NOT_FOUND_PATH = '/404';
export const FORBIDDEN_PATH = '/403';

// Private routes
export const ROOT_PATH = '/';
export const START_PATH = '/my-organizations';
export const ORG_RESOURCE_ID_PATH = '/:orgResourceId';
